// Copyright (c) 2016 Deere & Company

import RegistrationsReview from '../../../reports/registrations-review/state-connector';

export default {
    component: RegistrationsReview,
    name: 'REGISTRATIONS_REVIEW',
    path: 'registrations-review'
};




// WEBPACK FOOTER //
// ./src/routes/products/reports/registrations-review.js